import { paymentsApi } from '../httpService';


const reconcileTransactions = async (query: any) => {
    try {
        const result = await paymentsApi.get(`/api/v1/jobs/accounts/reconcile`, {
            params: query
        });

        return {
            success: true,
            data: result.data.data,
        };
    } catch (error: any) {
        return {
            success: false,
            message: "An unexpected Error"
        };
    }
}


export default {
    reconcileTransactions
}